<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="500px"
    min-width="300px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.layer.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            :error-messages="dialog.error.name"
            filled
            label="Tên hiển thị"
            no-label
          ></field-group>
        </v-col>
      </v-row>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_DATASTORE } from '@api'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {},
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, item))
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.$emit('test', this.dialog.data.name)
      this.$emit('gopublish')
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        let res = await API_DATASTORE.publish(
          this.dialog.data.datastore_id,
          this.dialog.data.id,
          {
            name: this.dialog.data.name,
          }
        )

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
